import { combineReducers } from 'redux';
import omit from 'lodash/omit';
import keyBy from 'lodash/keyBy';
import {
  FETCH_CONTESTS_SUCCESS,
  UPDATE_CONTEST_CLOSE,
  OMIT_CONTEST,
  UPDATE_CONTEST,
  FETCH_CONTESTS_STATUS,
} from './types';
import { getContestSeriesKey } from './actions';

/**
 * Reducer populates state structure
 * {
 *    [`duratrion-assetType-coin`]: [contestIds]
 * }
 */
const SeriesReducer = (state:any = {
  isFetched: true
}, { type, payload }:{type: any, payload:any}) => {
  switch (type) {

    case FETCH_CONTESTS_SUCCESS:
      if (!payload || payload.length === 0) {
        return state;
      }

      return payload.reduce(
        (drafState:any, contest:any) => {
          const seriesKey = getContestSeriesKey(contest);
          const contests = drafState[seriesKey] || [];
          if (!contests.includes(contest.id)) {
            drafState[seriesKey] = [...contests, contest.id];
          }
          return drafState;
        },
        { ...state }
      );

    case OMIT_CONTEST:
      if (!payload || !state[payload.seriesKey]) {
        return state;
      }

      const { seriesKey, idToOmit } = payload;

      return {
        ...state,
        [seriesKey]: state[seriesKey].filter((id:any) => id !== idToOmit),
      }
    case FETCH_CONTESTS_STATUS: 
      return {
        ...state,
        isFetched: payload
      }

    default:
      return state;
  }
};

/**
 * Contest Recuder produce state structure
 * {
 *    [contestId]: { ...contests }
 * }
 */
const ContestsReducer = (state:any = {}, { type, payload }:{type: any, payload:any}) => {
  switch (type) {
    case FETCH_CONTESTS_SUCCESS:
      if (!payload || payload.length === 0) {
        return state;
      }

      const keyedContests = keyBy(payload, 'id');
      return { ...state, ...keyedContests };

    case UPDATE_CONTEST:
      const { id, ...contest } = payload;
      if (!state[id]) {
        return state;
      }

      return {
        ...state,
        [id]: { ...state[id], ...contest },
      };

    case UPDATE_CONTEST_CLOSE: {
      const { id, status, pricing: instrumentPrices } = payload.contestUpdate;

      if (!state[id]) {
        return state;
      }

      return {
        ...omit(state, payload.idToOmit),
        [id]: { ...state[id], status, instrumentPrices },
      };
    }

    default:
      return state;
  }
};

export default combineReducers({
  series: SeriesReducer,
  contests: ContestsReducer,
});
